module.exports = __webpack_public_path__ + "img/blend3icon4.de92dce4.png";